import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { AddCoach } from './add-coach';

@Injectable()
export class AddCoachService {

    private requirePopupSource = new Subject<AddCoach>();
    private acceptPopupSource = new Subject<AddCoach>();
    private deletePopupSource = new Subject<AddCoach>();
    private updatePopupSource = new Subject<AddCoach>();
    // Observable string sources
    private tasks = new Subject<any>();
    // Observable string streams
    tasksConfirmed$ = this.tasks.asObservable();

    requirePopup$ = this.requirePopupSource.asObservable();
    accept = this.acceptPopupSource.asObservable();
    delete = this.deletePopupSource.asObservable();
    update = this.updatePopupSource.asObservable();

    confirm(popup: AddCoach) {
        this.requirePopupSource.next(popup);
        return this;
    }

    onAccept() {
        this.acceptPopupSource.next();
    }

    onDelete() {
        this.deletePopupSource.next();
    }

    onUpdate() {
        this.updatePopupSource.next();
    }

    postTask(task: any) {

        this.tasks.next(task);
    }

}
